import { useGetRefundReleaseAgent } from 'api-hooks/refund/refund-release-agent';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import RefundReleaseAgentForm from './components/form';

export type RefundReleaseAgentViewParams = {
  id: string;
};

export default function RefundReleaseAgentView(
  props: NavigationProps<NavigationRoutes.RefundReleaseAgentView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetRefundReleaseAgent({
      id,
    });

  const refundReleaseAgent = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <RefundReleaseAgentForm
            refundReleaseAgent={refundReleaseAgent}
            {...props}
          />
        </>
      }
    />
  );
}
